<template>
  <div>
    <a-row :gutter="16">
      <a-col class="gutter-row" :span="12">
        <a-list bordered>
          <a-list-item slot="renderItem" v-for="afdMessage in afdMessages" :key="afdMessage.id">
            <table>
              <tbody>
              <tr>
                <td>{{ afdMessage.message_id }}</td>
                <td>{{ afdMessage.contract_number }}</td>
                <td class="compact">
                  {{ afdMessage.agency_name }}
                </td>
                <td class="compact">
                  {{ afdMessage.branch_name }}
                </td>
                <td class="compact">
                  {{ new Date(afdMessage.datetime) | moment("D/MM/YYYY HH:MM:SS") }}
                </td>
              </tr>
              </tbody>
            </table>
          </a-list-item>
          <div slot="header">Gegroepeerde berichten</div>
        </a-list>
      </a-col>
      <a-col class="gutter-row" :span="12">
        <SiviMessageComponent :afd-message-id="afdMessage.id + ''"/>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from "../store";
import afdMessageApi from "~/api/afd_message";
import UnprocessedGroupedAFDMessageRowComponent
  from "~/modules/sivi/components/UnprocessedGroupedAFDMessageRowComponent";
import SiviMessageComponent from "./SiviMessageComponent";
// import store from '../store';

export default {
  name: "ProcessAFDMessageComponent",
  props: {
    afdMessage: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      afdMessages: [],
      currentPage: null,
      currentRequestData: {},
      allSelected: false,
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      staticSearches: '$_templating/staticSearches',
    }),
    indeterminate() {
      return this.allSelected === false
          && this.currentSelectionDiff !== this.afdMessages.length
          && this.currentSelectionDiff > 0;
    },
    currentSelectionDiff() {
      return this.afdMessages.filter(i => store.state.selectedAFDMessages.findIndex(x => x.id === i.id) < 0).length;
    },
    selectedAFDMessages() {
      return store.state.selectedAFDMessages;
    },
    displayPagination() {
      return typeof this.currentRequestData.meta !== "undefined";
    },
    hasSelection() {
      return this.selectedAFDMessages.length > 0;
    },
    selectedUnlinkableAfdMessages() {
      return this.selectedAFDMessages.filter(email => typeof email.customer !== "undefined" && email.customer !== null)
    },
    hasUnlinkableSelection() {
      return this.selectedUnlinkableAfdMessages.length > 0;
    },
  },
  created() {
    const STORE_KEY = '$_search';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    if (this.siviMessage === null && this.afdMessageId === null) {
      throw new Error('Either the sivi message or the afd message id must be provided via the props')
    } else if (this.sourceSiviMessage !== null) {
      this.siviMessage = this.sourceSiviMessage
    }
  },
  mounted() {
    afdMessageApi.getUnprocessedByGroupedAfdMessage(this.afdMessage.id).then(response => {
      this.afdMessages = response.data;
    });
  },
  components: {
    SiviMessageComponent,
    UnprocessedGroupedAFDMessageRowComponent
  },
  methods: {
    onTabChange() {

    },
    onUnmatchAllClick() {

    },
    onProcessAllClick() {

    },
    selectAFDMessage(afdMessage) {
      store.state.selectedAFDMessages.push(afdMessage);

      if (this.currentSelectionDiff === 0) {
        this.allSelected = true;
      }
    },
    selectAFDMessages(afdMessages) {
      for (let i in this.afdMessages) {
        this.selectAFDMessage(this.afdMessages[i]);
      }
    },
    deselectAFDMessage(afdMessage) {
      this.allSelected = false;

      store.state.selectedAFDMessages.splice(store.state.selectedAFDMessages.findIndex(x => x.id === afdMessage.id), 1);
    },
    deselectAFDMessages(afdMessages) {
      for (let i in this.afdMessages) {
        this.deselectAFDMessage(this.afdMessages[i]);
      }
    },
    onSelectAllChanged() {
      this.allSelected = !this.allSelected;

      for (let i in this.afdMessages) {
        let afdMessage = this.afdMessages[i];

        if (this.allSelected === true && store.state.selectedAFDMessages.findIndex(x => x.id === afdMessage.id) < 0) {
          this.selectAFDMessage(afdMessage);
        } else if (this.allSelected === false) {
          this.deselectAFDMessage(afdMessage);
        }
      }
    },
    onSelectionChanged(afdMessage, selected, shiftKey) {
      if (selected === true) {
        this.selectAFDMessage(afdMessage);
      } else {
        this.deselectAFDMessage(afdMessage);
      }
    },
    onProcessed() {

    },
    onUnmatched() {

    }
  }
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
